module.exports = __webpack_public_path__ + "static/media/one-on-one-dropdown-arrow.f7b014e0.svg";